import { ImageDisplay } from "@/components/Dialogs/ImageDisplay";
import Icon from "@/icons";

export default function AttachmentsDisplay({ attachments }: { attachments: { type: string, url: string, name: string, fileSizeBytes: number }[] }) {

    const convertToKB = (bytes: number) => {
        return Math.round(bytes / 1024);
    }

    return (
        <>
            {attachments.length > 0 && (
                <div className='flex flex-col gap-1 rounded-t-lg'>
                    {attachments.map((attachment, index) => (
                        <div key={index} className="relative flex items-center space-x-2 rounded-t-lg">
                            <div className="relativ rounded-full cursor-pointer">
                                {attachment.type === 'image' && (

                                    <ImageDisplay url={attachment.url}>
                                        <img src={attachment.url} className="w-auto max-h-96 rounded-lg" />
                                    </ImageDisplay>
                                )}

                                {attachment.type === 'video' && (
                                    <video src={attachment.url} className="max-w-64 max-h-64 rounded-lg" controls />
                                )}

                                {attachment.type === 'audio' && (
                                    <audio src={attachment.url} controls className="max-w-64 max-h-64 rounded-lg" />
                                )}

                                {attachment.type === 'file' && (
                                    <a href={attachment.url} target="_blank" rel="noreferrer" className="flex items-center  w-full text-white">
                                        <div className="flex items-center gap-3 p-3 bg-brand-dark rounded-lg borde border-gray-600 w-full">
                                            <Icon name="plus" size="24" color="white" />
                                            <div className="flex flex-col">
                                                <span className="font-semibold text-gray-200">{attachment.name.length > 20 ? `${attachment.name.slice(0, 20)}...` : attachment.name}</span>
                                                <span className="text-gray-400 text-sm">{convertToKB(attachment.fileSizeBytes)} KB</span>
                                            </div>
                                        </div>
                                    </a>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
}